// This file is generated by a prebuild script.
export const version = '3.844.1'
export const chameleonCoreVersion = '2.20.0'